<template>
    <b-row class="pmis-container row-eq-height intro-background">
        <b-col xl="3" lg="6">
            <b-row class="max-height">
                <b-col class="intro-tile" ref="igralnicaRef">
                    <p class="intro-title">Kaj je tehnološka igralnica?</p>
                    <p>
                        <span class="expose">Tehnološka igralnica</span> je okolje,
                        v katerem lahko spoznavate in
                        preskušate različne <span class="expose">tehnologije</span>
                        in <span class="expose">platforme</span> (igrala) za razvoj
                        <span class="expose">inovativnih rešitev</span> na področju
                        pametnih mest in skupnosti.
                        Svoje rešitve pa lahko delite in
                        promovirate na skupni <span class="expose">digitalni
                        tržnici</span>.
                    </p>
                </b-col>
            </b-row>
        </b-col>
        <b-col xl="3" lg="6">
            <b-row class="max-height">
                <b-col class="intro-tile">
                    <p class="intro-title">Komu je igralnica namenjena?</p>
                    <p>
                        Igralnica je namenjena vsem, ki
                        bi radi spoznali orodja za hiter
                        razvoj <span class="expose">informacijskih rešitev</span> z
                        uporabo modernih tehnologij
                        <span class="expose">interneta stvari</span>, <span class="expose">podatkovne
                        analitike</span> in <span class="expose">umetne inteligence</span>,
                        ki lahko ključno prispevajo k
                        <span class="expose">digitalizaciji</span> različnih področij
                        pametnega mesta in skupnosti.
                    </p>
                </b-col>
            </b-row>
        </b-col>
        <b-col xl="3" lg="6">
            <b-row class="max-height">
                <b-col class="intro-tile">
                    <p class="intro-title">Kaj lahko počnem v igralnici?</p>
                    <p>
                        V <span class="expose">igralnici</span> lahko razvijate nove
                        rešitve, ki vključujejo elemente
                        s celotnega spektra <span class="expose">interneta
                        stvari</span>, od zajema senzorskih
                        podatkov z uporabo različnih
                        <span class="expose">protokolov</span>, do analize podatkov
                        in razvoja <span class="expose">napovednih modelov</span>
                        ter <span class="expose">sofisticiranih nadzornih
                        plošč</span>...
                    </p>
                </b-col>
            </b-row>
        </b-col>
        <b-col xl="3" lg="6">
            <b-row class="max-height">
                <b-col class="intro-tile">
                    <p class="intro-title">Ali je lahko v igralnici tudi moja rešitev?</p>
                    <p>
                        Seveda, <span class="expose">igralnica</span> je namenjena
                        vsem tehnološkim okoljem, ki
                        lahko pripomorejo k <span class="expose">razvoju
                        inovativnih rešitev</span> na področju
                        pametnih mest in skupnosti.
                        Če menite, da vaša rešitev to
                        omogoča, nam pišite na naslov
                        <span class="expose">info@pmis.si</span>. Poslali vam bomo
                        še ostale pogoje za vključitev
                        v <span class="expose">igralnico</span>.
                    </p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "PmisIntro"
    }
</script>

<style lang="scss" scoped>
    .intro-background {
        background-color: $intro-background;
    }

    .intro-tile {
        min-width: 100px;
        background-color: white;
        margin: 10px 40px;
        border-radius: 10px;

        /*margin: 5px 5px;*/
    }

    .intro-title {
        font-size: 1.4em;
        font-family: "Roboto";
        color: $pmis-grey;
        text-align: center;
        margin-top: 10px;
    }
</style>
